import { FC } from 'react';

import Typography from '@mui/material/Typography';

const MainTitle: FC = () => {
  // TODO: @Incomplete make title again
  //const { pathname } = useLocation();
  //const route = ROUTES.find(route => selected(route, pathname));

  return (
    <Typography
      component="h1"
      variant="h6"
      color="inherit"
      noWrap
      sx={{ flexGrow: 1 }}>
      Tedo.lt administracija
    </Typography>
  );
};

export default MainTitle;
